(() => {
  'use strict';
  const dayMs = 86400000;
  const ordinal = n => n % 100 >= 11 && n % 100 <= 13 ? n + 'th' : n + ({1:'st',2:'nd',3:'rd'}[n % 10] || 'th');
  const iso = date => date.toISOString().slice(0, 10);
  const node = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  const todayLocal = () => {
    const now = new Date();
    return new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()));
  };
  const occurrence = (event, year) => {
    if (event.rule === 'one_time' && year !== event.year || event.originalYear && year < event.originalYear) return null;
    let start;
    if (event.rule === 'nth_weekday') {
      const first = new Date(Date.UTC(year, event.month - 1, 1));
      start = new Date(Date.UTC(year, event.month - 1, 1 + (event.weekday - first.getUTCDay() + 7) % 7 + (event.occurrence - 1) * 7));
      if (start.getUTCMonth() !== event.month - 1) return null;
    } else {
      start = new Date(Date.UTC(year, event.month - 1, event.day));
      if (start.getUTCMonth() !== event.month - 1 || start.getUTCDate() !== event.day) return null;
    }
    const years = event.originalYear > 0 ? year - event.originalYear : 0;
    const milestone = years > 0 && (years % 10 === 0 || years === 25 || years === 75);
    const specialAnniversary = milestone && !event.sensitive && event.kind !== 'remembrance';
    return {...event, start, end:new Date(start.getTime() + ((event.duration || 1) - 1) * dayMs), years, milestone, specialAnniversary, indicative:event.rule === 'nth_weekday' && !(event.confirmedYears || []).includes(year)};
  };
  const initialise = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const labels = JSON.parse(root.querySelector('[data-calendar-labels]').textContent);
    let events = JSON.parse(root.querySelector('[data-calendar-catalogue]').textContent);
    const metadata = new Map(events.map(e => [e.id, e]));
    let today = todayLocal(), firstYear = today.getUTCFullYear();
    let years = Array.from({length:5}, (_, i) => firstYear + i);
    const months = Array.from({length:12}, (_, i) => new Intl.DateTimeFormat('en-AU', {month:'long', timeZone:'UTC'}).format(new Date(Date.UTC(2000, i, 1))));
    const shortDate = date => new Intl.DateTimeFormat('en-AU', {day:'numeric', month:'short', timeZone:'UTC'}).format(date);
    const longDate = date => new Intl.DateTimeFormat('en-AU', {day:'numeric', month:'long', year:'numeric', timeZone:'UTC'}).format(date);
    const form = root.querySelector('[data-filters]');
    const controls = {q:form.elements.q, region:form.elements.region, view:form.elements.view, national:form.elements.national, past:form.elements.past};
    const regionNames = {'Nationwide':labels.nationwide,'ACT':'Australian Capital Territory','NSW':'New South Wales','NT':'Northern Territory','QLD':'Queensland','SA':'South Australia','TAS':'Tasmania','VIC':'Victoria','WA':'Western Australia','Torres Strait':'Torres Strait','International':labels.international};
    let state = {year:firstYear, q:'', region:'all', view:'all', national:true, past:false};
    let searchTimer;
    controls.region.append(new Option(labels.all_regions, 'all'));
    Object.entries(regionNames).forEach(([code, name]) => controls.region.append(new Option(name, code)));
    const readLocation = () => {
      const params = new URL(location.href).searchParams;
      const y = Number(params.get('year'));
      state = {year:years.includes(y) ? y : firstYear, q:(params.get('q') || '').slice(0, 150), region:params.get('region') === 'all' || Object.hasOwn(regionNames, params.get('region')) ? params.get('region') : 'all', view:['milestones','remembrance','summary'].includes(params.get('view')) ? params.get('view') : 'all', national:params.get('national') !== '0', past:params.get('past') === '1'};
      controls.q.value = state.q;
      controls.region.value = state.region;
      controls.view.value = state.view;
      controls.national.checked = state.national;
      controls.past.checked = state.past;
    };
    const writeLocation = () => {
      const url = new URL(location.href);
      ['year','q','region','view','national','past'].forEach(k => url.searchParams.delete(k));
      url.searchParams.set('year', String(state.year));
      if (state.q) url.searchParams.set('q', state.q);
      if (state.region !== 'all') url.searchParams.set('region', state.region);
      if (state.view !== 'all') url.searchParams.set('view', state.view);
      if (!state.national) url.searchParams.set('national', '0');
      if (state.past) url.searchParams.set('past', '1');
      history.replaceState(null, '', url);
    };
    const matches = event => {
      const region = state.region === 'all' || event.regions.includes(state.region) || state.national && !['Nationwide','International'].includes(state.region) && event.regions.includes('Nationwide');
      const haystack = [event.title, event.summary, ...event.regions.map(r => regionNames[r] || r)].join(' ').normalize('NFKD').toLowerCase();
      const search = state.q.normalize('NFKD').toLowerCase().split(/\s+/).every(word => haystack.includes(word));
      return region && search;
    };
    const entriesFor = year => events.map(e => occurrence(e, year)).filter(Boolean).filter(matches).filter(e => year !== firstYear || state.past || e.end >= today).sort((a, b) => a.start - b.start || a.title.localeCompare(b.title));
    const badge = (text, modifier) => node('span', 'bfn-planner__badge' + (modifier ? ' bfn-planner__badge--' + modifier : ''), text);
    const bodyFor = event => {
      const body = node('div', 'bfn-planner__event-body');
      const h3 = node('h3');
      const link = node('a', '', event.title);
      link.href = event.url;
      h3.append(link);
      body.append(h3);
      if (event.summary) body.append(node('p', 'bfn-planner__event-summary', event.summary));
      if (event.originalYear > 0) body.append(node('p', 'bfn-planner__origin', labels.origin + ': ' + event.day + ' ' + months[event.month - 1] + ' ' + event.originalYear));
      if (event.regionalNote) {
        const note = node('p', 'bfn-planner__regional-note', event.regionalNote);
        if (event.regionalSource) {const source = node('a', '', labels.connection_source);source.href=event.regionalSource;source.target='_blank';source.rel='noopener noreferrer';note.append(document.createTextNode(' '),source);}
        body.append(note);
      }
      if (event.indicative) body.append(node('p', 'bfn-planner__pattern-note', labels.indicative_note));
      const more = node('a', 'bfn-planner__read', labels.read + ' →');
      more.href = event.url;
      body.append(more);
      return body;
    };
    const eventCard = event => {
      const card = node('article', 'bfn-planner__event' + (event.milestone ? ' bfn-planner__event--milestone' : ''));
      card.dataset.eventId = event.id;
      card.dataset.eventDate = iso(event.start);
      card.dataset.sensitive = String(event.sensitive);
      const tags = node('div', 'bfn-planner__tags');
      (event.regions.length ? event.regions : ['untagged']).forEach(r => {const tag=badge(regionNames[r] || (r === 'untagged' ? labels.untagged : r));tag.dataset.region=r;tags.append(tag);});
      if (event.milestone) tags.append(badge(event.kind === 'remembrance' ? labels.milestone_remembrance : event.sensitive ? labels.milestone_sensitive : labels.milestone, event.sensitive || event.kind === 'remembrance' ? 'remembrance' : 'gold'));
      if (event.years > 0) tags.append(badge(event.kind === 'remembrance' || event.sensitive ? event.years + ' ' + labels.years_on : event.kind === 'birth' ? event.years + ' ' + labels.birth_years : ordinal(event.years) + ' ' + labels.anniversary, 'years'));
      else tags.append(badge(labels.annual, 'years'));
      if (event.indicative) tags.append(badge(labels.indicative, 'pending'));
      card.append(tags);
      const body = bodyFor(event);
      if (event.sensitive) {
        const details = node('details', 'bfn-planner__sensitive');
        const summary = node('summary');
        const icon = node('span', 'bfn-planner__warning', '!');
        icon.setAttribute('aria-hidden', 'true');
        summary.append(icon, node('strong', '', event.kind === 'remembrance' ? labels.sensitive_remembrance : labels.sensitive), node('span', 'bfn-planner__reveal', labels.reveal));
        details.append(summary, node('p', 'bfn-planner__sensitive-note', labels.sensitive_note), body);
        card.append(details);
      } else card.append(body);
      return card;
    };
    const render = () => {
      root.querySelector('[data-catalogue-count]').textContent = String(events.length);
      const yearNav = root.querySelector('[data-years]');
      const chooseView = (year, view, focusSelector) => {
        state.year = year; state.view = view; controls.view.value = view;
        writeLocation(); render();
        if (focusSelector) root.querySelector(focusSelector)?.focus({preventScroll:true});
      };
      const yearButtons = years.map(year => {
        const entries = entriesFor(year);
        const card = node('div', 'bfn-planner__year-card' + (year === state.year ? ' is-selected' : ''));
        const button = node('button', 'bfn-planner__year');
        button.type = 'button';
        button.setAttribute('aria-pressed', String(year === state.year));
        button.dataset.year = String(year);
        button.append(node('strong', '', String(year)), node('span', '', entries.length + ' ' + labels.count_dates));
        button.addEventListener('click', () => chooseView(year, state.view === 'summary' ? 'all' : state.view, '[data-year="' + year + '"]'));
        const counts = node('div', 'bfn-planner__year-counts');
        [['milestones', entries.filter(e => e.specialAnniversary).length, labels.count_milestones],
         ['remembrance', entries.filter(e => e.kind === 'remembrance').length, labels.count_remembrance]].forEach(([view, count, label]) => {
          const countButton = node('button', 'bfn-planner__year-count', count + ' ' + label);
          countButton.type = 'button'; countButton.dataset.yearView = view; countButton.dataset.forYear = String(year);
          countButton.setAttribute('aria-label', year + ': ' + count + ' ' + label);
          countButton.setAttribute('aria-pressed', String(year === state.year && state.view === view));
          countButton.addEventListener('click', () => chooseView(year, view, '[data-for-year="' + year + '"][data-year-view="' + view + '"]'));
          counts.append(countButton);
        });
        card.append(button, counts);
        return card;
      });
      yearNav.replaceChildren(...yearButtons);
      const all = entriesFor(state.year);
      let visible = all.filter(e => state.view !== 'milestones' || e.specialAnniversary).filter(e => state.view !== 'remembrance' || e.kind === 'remembrance');
      const summaryMode = state.view === 'milestones' || state.view === 'summary';
      if (state.view === 'summary') visible = years.flatMap(year => entriesFor(year).filter(e => e.specialAnniversary));
      yearNav.hidden = state.view === 'summary';
      root.querySelectorAll('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === state.view)));
      root.querySelector('.bfn-planner__layout').classList.toggle('bfn-planner__layout--single-summary',state.view === 'milestones');
      root.querySelector('[data-past-option]').hidden = state.year !== firstYear && state.view !== 'summary';
      controls.national.disabled = state.region === 'all' || ['Nationwide','International'].includes(state.region);
      const overview = root.querySelector('[data-overview]');
      const overviewEntries = state.view === 'summary' ? years.flatMap(year => entriesFor(year)) : all;
      const stat = (n, text, view) => {
        const button = node('button', 'bfn-planner__stat');
        button.type = 'button'; button.dataset.statView = view;
        button.setAttribute('aria-pressed', String(state.view === view));
        button.append(node('strong', '', String(n)), node('span', '', text));
        button.addEventListener('click', () => chooseView(state.year, view, '[data-stat-view="' + view + '"]'));
        return button;
      };
      overview.replaceChildren(stat(overviewEntries.length, labels.count_dates, 'all'), stat(overviewEntries.filter(e => e.specialAnniversary).length, labels.count_milestones, 'milestones'), stat(overviewEntries.filter(e => e.kind === 'remembrance').length, labels.count_remembrance, 'remembrance'));
      root.querySelector('[data-result-count]').textContent = visible.length + ' ' + labels.results + ' · ' + state.year;
      root.querySelector('[data-empty]').hidden = visible.length > 0;
      const monthNav = root.querySelector('[data-month-nav]');
      monthNav.replaceChildren(node('p', 'bfn-planner__month-label', labels.months));
      const sections = [];
      monthNav.hidden = state.view === 'milestones';
      if (summaryMode) {
        root.querySelector('[data-result-count]').textContent = visible.length + ' ' + labels.summary_results + ' · ' + (state.view === 'summary' ? years[0] + '–' + years[4] : state.year);
        monthNav.replaceChildren(node('p','bfn-planner__month-label',labels.jump_year));
        const intro = node('p','bfn-planner__summary-intro',labels.summary_intro);
        sections.push(intro);
        (state.view === 'summary' ? years : [state.year]).forEach(year => {
          const entries = visible.filter(e => e.start.getUTCFullYear() === year);
          if (!entries.length) return;
          const group = node('section','bfn-planner__summary-year');
          group.id = root.id + '-summary-' + year;
          group.dataset.summaryYear = String(year);
          const h2=node('h2','bfn-planner__month-heading',String(year));
          h2.append(node('span','',entries.length + ' ' + labels.count_milestones));
          group.append(h2);
          entries.forEach(event => {
            const row=node('article','bfn-planner__summary-row');
            row.dataset.eventId=event.id;row.dataset.eventDate=iso(event.start);row.dataset.sensitive=String(event.sensitive);
            const date=node('time','bfn-planner__summary-date',shortDate(event.start));date.dateTime=iso(event.start);date.setAttribute('aria-label',longDate(event.start));
            const content=node('div','bfn-planner__summary-content');
            const h3=node('h3');const link=node('a','',event.title);link.href=event.url;h3.append(link);
            const tags=node('div','bfn-planner__tags');
            tags.append(badge(ordinal(event.years)+' '+labels.anniversary,'gold'));
            event.regions.forEach(region=>{const tag=badge(regionNames[region]||region);tag.dataset.region=region;tags.append(tag);});
            content.append(h3,tags);row.append(date,content);group.append(row);
          });
          const jump=node('a','',String(year));jump.href='#'+group.id;jump.append(node('span','',String(entries.length)));monthNav.append(jump);sections.push(group);
        });
        root.querySelector('[data-months]').replaceChildren(...sections);
        return;
      }
      months.forEach((name, index) => {
        const entries = visible.filter(e => e.start.getUTCMonth() === index);
        const id = root.id + '-month-' + (index + 1);
        if (entries.length) {
          const a = node('a', '', name);
          a.href = '#' + id;
          a.append(node('span', '', String(entries.length)));
          monthNav.append(a);
        }
        if (!entries.length) return;
        const month = node('section', 'bfn-planner__month');
        month.id = id;
        month.dataset.month = String(index + 1);
        const h2 = node('h2', 'bfn-planner__month-heading', name);
        h2.append(node('span', '', entries.length + ' ' + labels.month_count));
        month.append(h2);
        const grouped = new Map();
        entries.forEach(e => {const key = iso(e.start);if (!grouped.has(key)) grouped.set(key, []);grouped.get(key).push(e);});
        grouped.forEach((dayEvents, date) => {
          const group = node('div', 'bfn-planner__day');
          const rail = node('div', 'bfn-planner__date-rail');
          const time = node('time', '', String(dayEvents[0].start.getUTCDate()));
          time.dateTime = date;
          time.setAttribute('aria-label', longDate(dayEvents[0].start));
          rail.append(time, node('span', '', new Intl.DateTimeFormat('en-AU', {weekday:'short', timeZone:'UTC'}).format(dayEvents[0].start)));
          if (iso(today) === date) rail.append(badge(labels.today, 'gold'));
          const cards = node('div', 'bfn-planner__day-events');
          dayEvents.forEach(e => {
            const card = eventCard(e);
            if (e.duration > 1) card.prepend(node('p', 'bfn-planner__range', shortDate(e.start) + ' – ' + shortDate(e.end)));
            cards.append(card);
          });
          group.append(rail, cards);
          if (dayEvents.every(e => e.end < today)) group.classList.add('bfn-planner__day--past');
          month.append(group);
        });
        sections.push(month);
      });
      root.querySelector('[data-months]').replaceChildren(...sections);
    };
    const readForm = () => {
      state.q = controls.q.value.trim().slice(0, 150);
      state.region = controls.region.value;
      state.view = controls.view.value;
      state.national = controls.national.checked;
      state.past = controls.past.checked;
      writeLocation();render();
    };
    root.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => {controls.view.value=button.dataset.view;clearTimeout(searchTimer);readForm();}));
    form.addEventListener('submit', event => {event.preventDefault();clearTimeout(searchTimer);readForm();});
    form.addEventListener('change', () => {clearTimeout(searchTimer);readForm();});
    controls.q.addEventListener('input', () => {clearTimeout(searchTimer);searchTimer = setTimeout(readForm, 160);});
    root.querySelectorAll('[data-reset]').forEach(button => button.addEventListener('click', () => {clearTimeout(searchTimer);state = {year:state.year, q:'', region:'all', view:'all', national:true, past:false};controls.q.value='';controls.region.value='all';controls.view.value='all';controls.national.checked=true;controls.past.checked=false;writeLocation();render();}));
    root.querySelector('[data-print]').addEventListener('click', () => window.print());
    window.addEventListener('popstate', () => {readLocation();render();});
    readLocation();form.hidden = false;render();

    let localTimer;
    const localLifecycle = new AbortController();
    const refreshLocalDate = () => {
      clearTimeout(localTimer);
      if (!root.isConnected) {localLifecycle.abort();return;}
      const nextToday = todayLocal();
      if (nextToday.getTime() !== today.getTime()) {
        today = nextToday; firstYear = today.getUTCFullYear();
        years = Array.from({length:5}, (_, i) => firstYear + i);
        readLocation(); render();
      }
      localTimer = setTimeout(refreshLocalDate, 60000 - Date.now() % 60000 + 25);
    };
    document.addEventListener('visibilitychange', () => {if (!document.hidden) refreshLocalDate();}, {signal:localLifecycle.signal});
    window.addEventListener('focus', refreshLocalDate, {signal:localLifecycle.signal});
    refreshLocalDate();
    const sourceUrl = new URL(root.dataset.rootUrl || '/', location.origin);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) sourceUrl.searchParams.set('preview_theme_id', preview);
    fetch(sourceUrl, {credentials:'same-origin', signal:AbortSignal.timeout(7000)}).then(response => {
      if (!response.ok) throw new Error('Calendar source unavailable');
      return response.text();
    }).then(html => {
      const opening = /<section\b[^>]*\bclass="[^"]*\brolling-key-dates\b[^"]*"[^>]*>/i.exec(html);
      if (!opening) return;
      const end = html.indexOf('</section>', opening.index);
      if (end < 0) return;
      const doc = new DOMParser().parseFromString(html.slice(opening.index, end + 10), 'text/html');
      const source = [...doc.querySelectorAll('.rolling-key-dates__track > .rolling-key-dates__card[data-rule]')];
      if (!source.length) return;
      const fresh = [];
      const add = event => {
        if (!event.title || !event.url || !event.url.startsWith('/pages/')) return;
        const id = event.url.split('/').filter(Boolean).pop();
        const meta = metadata.get(id);
        fresh.push({...event, id, regions:meta?.regions || [], kind:meta?.kind || (/massacre|remembrance/i.test(event.title) ? 'remembrance' : /birth anniversary/i.test(event.title) ? 'birth' : 'anniversary'), confirmedYears:meta?.confirmedYears || [], regionalNote:meta?.regionalNote || '', regionalSource:meta?.regionalSource || ''});
      };
      source.forEach(card => {
        const d = card.dataset;
        const common = {rule:d.rule, year:Number(d.year), month:Number(d.month), day:Number(d.day), weekday:Number(d.weekday), occurrence:Number(d.occurrence), duration:Math.max(1, Number(d.duration) || 1)};
        add({...common,title:card.querySelector('.rolling-key-dates__title')?.textContent.trim(),summary:card.querySelector('.rolling-key-dates__summary')?.textContent.trim() || '',url:card.querySelector('a.rolling-key-dates__card-link')?.getAttribute('href') || '',originalYear:Number(d.originalYear) || 0,sensitive:d.sensitive === 'true'});
        [1,2,3].forEach(n => {
          if (!d['related'+n+'Title']) return;
          const month = Number(d['related'+n+'Month']), day = Number(d['related'+n+'Day']);
          add({...common,...(month > 0 && day > 0 ? {rule:'annual',month,day,duration:1} : {}),title:d['related'+n+'Title'],summary:d['related'+n+'Summary'] || '',url:d['related'+n+'Url'] || '',originalYear:Number(d['related'+n+'Year']) || 0,sensitive:d['related'+n+'Sensitive'] === 'true'});
        });
      });
      if (fresh.length && new Set(fresh.map(e => e.id)).size === fresh.length) {
        const fingerprint = list => JSON.stringify(list.map(e => [e.id,e.title,e.summary,e.url,e.rule,e.year,e.month,e.day,e.weekday,e.occurrence,e.duration,e.originalYear,e.sensitive]).sort((a,b) => a[0].localeCompare(b[0])));
        if (fingerprint(fresh) !== fingerprint(events)) {events = fresh;render();}
      }
    }).catch(() => {});
  };
  const start = scope => scope.querySelectorAll('[data-calendar-planner]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document));
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
